export default class StaticAnnouncement {
    constructor(section) {
        // Since the announcement bar positioning is actually handled by the
        // StaticSectionHeader and StickyHeader classes, we need to let them know
        // when the announcement element is refreshed within the editor.
        if (globalThis.Shopify && globalThis.Shopify.designMode) {
            section.postMessage('announcement:load');
        }
    }
}
